import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "slim-arrow-right";
const pathData = "M172.5 154q-9-11-9-22 0-13 9-22 11-9 22-9 13 0 22 9l124 124q9 9 9 22 0 11-9 22l-124 124q-9 9-22 9-11 0-22-9-9-11-9-22 0-13 9-22l103-102z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/slim-arrow-right";
export { pathData, ltr, accData };